// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8a3bfcad","703":"bad129ba","787":"78b604ed"}[chunkId] + ".chunk.js";
};